import { forwardRef, HtmlHTMLAttributes, memo } from "react";
import classNames from "classnames";

import styles from "./style.module.scss"

export type CommandBarFooterNavigationItemProps = {
  supportingText?: string
  shortcutsBoxClassName?: string
  supportingTextClassName?: string
} & HtmlHTMLAttributes<HTMLDivElement>

export const CommandBarFooterNavigationItem = memo(forwardRef<HTMLDivElement, CommandBarFooterNavigationItemProps>((
  {
    children,
    className,
    supportingText,
    shortcutsBoxClassName,
    supportingTextClassName,
    ...props
  }, ref) => {
  return (
    <div
      className={classNames(className, styles.root)}
      {...props}
      ref={ref}
    >
      <div className={classNames(shortcutsBoxClassName, styles.shortcutsBox)}>
        {children}
      </div>
      <span className={classNames(supportingTextClassName, styles.supportingText)}>{supportingText}</span>
    </div>
  );
}));